import { ChainId } from '@pulsex/chains'

export const masterChefAddresses = {
  [ChainId.PULSECHAIN]: '0xB2Ca4A66d3e57a5a9A12043B6bAD28249fE302d4',
  [ChainId.PULSECHAIN_TESTNET]: '0x3b34Fff74497cA21771ce9a0c11cb07490686A58',
} as const
